export class RentalAllowedStatus {
    private _rentalItemId: number;
    private _isAllowed: boolean;
    private _errorMessage: string;

    constructor(rentalItemId: number, isAllowed: boolean, errorMessage?: string) {
        this._rentalItemId = rentalItemId;
        this._isAllowed = isAllowed;
        this._errorMessage = errorMessage || "";
    }

    // Getter methods for each property
    get rentalItemId(): number {
        return this._rentalItemId;
    }

    get isAllowed(): boolean {
        return this._isAllowed;
    }

    get errorMessage(): string {
        return this._errorMessage;
    }
}